import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService } from '../../../core/user.service';

@Component({
  selector: 'app-login-multi-role',
  templateUrl: './login-multi-role.component.html',
  styleUrls: ['./login-multi-role.component.css']
})
export class LoginMultiRoleComponent implements OnInit {
  userId;
  user;
  selectedRole;
  userRoles=new Array();
  hostUrl;
  constructor(private http: HttpClient, private router: Router, private route: ActivatedRoute,private userService: UserService) { }

  ngOnInit() {
    this.hostUrl=this.userService.getUrl();
    this.userId=this.route.snapshot.params['user_id'];
    this.http.get(encodeURI(this.hostUrl + '/api/issue/loginRole/'+this.userId))      
                        .subscribe((data) => {
                          this.user=data;
                          this.http.get(encodeURI(this.hostUrl + '/api/issue/roleName/'+this.user[0].AccRole)).subscribe((data) => {this.userRoles.push(data)})
                          this.http.get(encodeURI(this.hostUrl + '/api/issue/roleName/'+this.user[0].ProjRole)).subscribe((data) => {this.userRoles.push(data)});
                        })
  }

  onNavigate(){
    if(this.selectedRole==2){
      localStorage.setItem('CurrentRole', '2');
       this.router.navigate(['/ah']);
    }else{
      if(this.selectedRole==4){
        localStorage.setItem('CurrentRole', '4');
        this.router.navigate(['/home']);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login-page/login-multi-role/login-multi-role.component.ts